/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React from "react";
import { format } from "date-fns";
import NumberCell from "../../tableFields/NumberCell";
import NumberCellNegative from "../../tableFields/NumberCellNegative";

export const PROJECT_SUMMARY_COLUMNS = [
  {
    Header: "Customer Name",
    accessor: "customer",
    id: "customer",
    minWidth: 250
  },
  {
    Header: "Project Name",
    accessor: "name",
    id: "name",
    minWidth: 250
  },
  {
    Header: "Due Date",
    accessor: "due_date",
    id: "due_date",
    Cell: ({ value }) => (value ? format(new Date(value), "MM/dd/yyyy") : "--"),
    minWidth: 100
  },
  {
    Header: "Start Date",
    accessor: "start_date",
    id: "start_date",
    Cell: ({ value }) => (value ? format(new Date(value), "MM/dd/yyyy") : "--"),
    minWidth: 120
  },
  {
    Header: "End Date",
    accessor: "end_date",
    id: "end_date",
    Cell: ({ value }) => (value ? format(new Date(value), "MM/dd/yyyy") : "--"),
    minWidth: 120
  },
  {
    Header: "Category",
    accessor: "category",
    id: "category",
    minWidth: 100
  },
  {
    Header: "Department",
    accessor: "department",
    id: "department",
    minWidth: 90
  },
  {
    Header: "Project Manager",
    accessor: "project_manager",
    id: "project_manager",
    minWidth: 120
  },
  {
    Header: "Status",
    accessor: "status",
    id: "project_status",
    minWidth: 100
  },
  {
    Header: "Project Type",
    accessor: "project_type",
    id: "project_type",
    minWidth: 120
  },
  {
    Header: "Primary Resource",
    accessor: "resource1",
    id: "resource1",
    minWidth: 120
  },
  {
    Header: "Secondary Resource",
    accessor: "resource2",
    id: "resource2",
    minWidth: 120
  },
  {
    Header: "Budget Amount",
    accessor: "budget_amount",
    id: "budget_amount",
    minWidth: 120,
    Cell: ({ value }) =>
      Number(value)?.toFixed(2) !== "NaN" ? Number(value)?.toFixed(2) : "0.00"
  },
  {
    Header: "Budget Hours",
    accessor: "budget_hours",
    id: "budget_hours",
    minWidth: 100,
    Cell: ({ value }) =>
      Number(value)?.toFixed(2) !== "NaN" ? Number(value)?.toFixed(2) : "0.00"
  },
  {
    Header: "Billed Hours",
    accessor: "billed_hours",
    id: "billed_hours",
    minWidth: 100,
    Cell: ({ value }) =>
      Number(value)?.toFixed(2) !== "NaN" ? Number(value)?.toFixed(2) : "0.00"
  },
  {
    Header: "Balance Avail",
    accessor: "balance",
    id: "balance",
    minWidth: 120,
    Cell: ({ value }) => (
      <NumberCellNegative
        getValue={(val) => Number(val)?.toFixed(2) || 0}
        value={value}
      />
    )
  },
  {
    Header: "Balance Rem %",
    accessor: "balanceRem",
    id: "balanceRem",
    minWidth: 120,
    Cell: ({ value }) => (
      <NumberCellNegative
        getValue={(val) => Number(val)?.toFixed(2) || 0}
        value={value}
      />
    )
  },
  {
    Header: "Billable Actual Hours",
    accessor: "actualHours",
    id: "actualHours",
    minWidth: 100,
    Cell: ({ value }) =>
      Number(value)?.toFixed(2) !== "NaN" ? Number(value)?.toFixed(2) : "0.00"
  },
  {
    Header: "As Billed Hours",
    accessor: "asBilledHours",
    id: "asBilledHours",
    minWidth: 100,
    Cell: ({ value }) =>
      Number(value)?.toFixed(2) !== "NaN" ? Number(value)?.toFixed(2) : "0.00"
  },
  {
    Header: "Credit Hours",
    accessor: "creditHours",
    id: "creditHours",
    minWidth: 100,
    Cell: ({ value }) =>
      Number(value)?.toFixed(2) !== "NaN" ? Number(value)?.toFixed(2) : "0.00"
  },
  {
    Header: "Capital Hours",
    accessor: "capitalHours",
    id: "capitalHours",
    minWidth: 100,
    Cell: ({ value }) =>
      Number(value)?.toFixed(2) !== "NaN" ? Number(value)?.toFixed(2) : "0.00"
  },
  {
    Header: "Overhead Hours",
    accessor: "overheadHours",
    id: "overheadHours",
    minWidth: 100,
    Cell: ({ value }) =>
      Number(value)?.toFixed(2) !== "NaN" ? Number(value)?.toFixed(2) : "0.00"
  },
  {
    Header: "Total Actual Hours",
    accessor: "totalHours",
    id: "totalHours",
    minWidth: 100,
    Cell: ({ value }) =>
      Number(value)?.toFixed(2) !== "NaN" ? Number(value)?.toFixed(2) : "0.00"
  },
  {
    Header: "Billing Rate",
    accessor: "rate",
    id: "rate",
    minWidth: 100,
    Cell: ({ value }) =>
      Number(value)?.toFixed(2) !== "NaN" ? Number(value)?.toFixed(2) : "0.00"
  },
  {
    Header: "Yield",
    accessor: "yield",
    id: "yield",
    minWidth: 120,
    Cell: ({ value }) => <NumberCell value={`$${value || 0}`} />
  },
  {
    Header: "Notes",
    accessor: "notes.0.note",
    id: "notes",
    minWidth: 225,
    Cell: ({ value }) => {
      if (Array.isArray(value) && value.length) {
        return value[value.length - 1].note.replace(/<[^>]*>?/gm, "");
      }
      if (typeof value === "string") {
        return value.replace(/<[^>]*>?/gm, "");
      }
      return "";
    }
  }
];
